/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef } from 'react';
import { useState, useEffect, useContext } from "react";
import SetupModal from "./SetupModal";
import { openDB } from "idb";
import styles from "../css/SetupForm.module.css";
import Context from '../context/context';
import ImageInput from './ImageInput';

const MAX_CHARS = {
  outlet_title: 42,
  outlet_mobile: 15,
  outlet_email: 50,
  outlet_address: 200,
  outlet_area_pin: 10,
  outlet_town: 42,
  outlet_district: 42,
  outlet_state: 42,
  outlet_country: 42,
};

const server = 'https://api.myfooddo.com'
// const server = 'http://localhost:5000'
const outlet_uuid = localStorage.getItem('outlet_uuid')

function OutletDetailsSetupForm({ onSave }) {
  const [outletDetailsSetup, setOutletDetailsSetup] = useState({});
  const [customizationModalOpen, setCustomizationModalOpen] = useState(false);
  const context = useContext(Context);
  const {
    fetchImage,
    uploadImage,
    updateUnSync
  } = context;

  const [imageSRC, setImageSRC] = useState('');
  const imageInputRef = useRef('')

  //Fetching all the existing outlets form indexDB
  useEffect(() => {
    const getData = async () => {
      const db = await openDB('FoodDo', +localStorage.getItem('IDBVersion') || 1);
      const outletStore = db.transaction("outlet", "readwrite").objectStore("outlet");
      const value = await outletStore.getAll();
      setOutletDetailsSetup(value[0].outlet_details)
      fetchImage({ setState: setImageSRC, url: `${server}/outlet-images/${value[0].outlet_uuid}.webp` })
    }
    getData()
  }, [])

  // On setup submit
  const handleSubmit = async (event) => {
    event.preventDefault();
    const db = await openDB('FoodDo', +localStorage.getItem('IDBVersion') || 1);
    const outletStore = db.transaction("outlet", "readwrite").objectStore("outlet");
    const value = (await outletStore.getAll())[0];
    const updatedValue = { ...value, outlet_details: outletDetailsSetup };
    localStorage.setItem('outlet-name', outletDetailsSetup?.outlet_title);
    await outletStore.put(updatedValue);
    handleOutletUnsyncedFile(updatedValue);

    if (imageInputRef?.current?.files?.[0]) uploadImage({
      image: imageInputRef.current.files[0],
      url: `${server}/upload/outlet-images/${outlet_uuid}/webp`
    })
    onSave();
  };

  // Adding/Editing  outlet details to unsynced_files collection in IndexedDB
  const handleOutletUnsyncedFile = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db.transaction("unsynced_files", "readwrite").objectStore("unsynced_files");
    const ndata = {
      IDENTIFIER: "outlet_details",
      RECON_TIME: Date.now(),
      outlet_details: data.outlet_details,
    };
    await tx.put(ndata);
    handleOutletReconciliation(ndata);
    updateUnSync()
  };

  // Adding/Editing category to reconciliation collection in IndexedDB
  const handleOutletReconciliation = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db.transaction("reconciliation", "readwrite").objectStore("reconciliation");
    const allReconRecords = await tx.getAll();

    const othersJsonExists = allReconRecords.find((curr) => curr.IDENTIFIER === "others");
    if (othersJsonExists) {
      const outletDetails = othersJsonExists?.details?.filter((entry) => entry.type !== 'outlet_details')
      const editData = {
        ...othersJsonExists,
        details: [
          ...outletDetails,
          {
            type: 'outlet_details',
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.put(editData)
    } else {
      const newdata = {
        IDENTIFIER: "others",
        details: [
          {
            type: 'outlet_details',
            RECON_TIME: data.RECON_TIME,
          },
        ]
      };
      await tx.add(newdata);
    }
  }

  return (
    <>
      <form className={styles.form} onSubmit={handleSubmit}>
        <div className={styles.heading}>
          <h1>Outlet Details Setup</h1>
        </div>

        <div className={styles.formContainer}>
          <div className={styles.formGroup}>

            <div className={styles.generalTop}>
              <h2>General Details</h2>

              <ImageInput
                lableText={'Outlet Image'}
                imageSRC={imageSRC}
                setImageSRC={setImageSRC}
                imageInputRef={imageInputRef}
                classList={{}}
                URLs={{
                  delete: `${server}/delete/outlet-images/${outlet_uuid}.webp`
                }}
              />
            </div>

            <div className={styles.row}>
              <label className={styles.selectLabel}>
                Outlet Title
                <input
                  type="text"
                  name="outlet_title"
                  className={styles.numberInput}
                  value={outletDetailsSetup?.outlet_title}
                  maxLength={MAX_CHARS.outlet_title}
                  onChange={(e) =>
                    setOutletDetailsSetup({
                      ...outletDetailsSetup,
                      outlet_title: e.target.value,
                    })
                  }
                />
              </label>

              <label className={styles.selectLabel}>
                Outlet Mobile
                <input
                  type="text"
                  name="outlet_mobile"
                  className={styles.numberInput}
                  value={outletDetailsSetup?.outlet_mobile}
                  maxLength={MAX_CHARS.outlet_mobile}
                  onChange={(e) =>
                    setOutletDetailsSetup({
                      ...outletDetailsSetup,
                      outlet_mobile: e.target.value,
                    })
                  }
                />
              </label>
              <label className={styles.selectLabel}>
                Outlet Email
                <input
                  type="email"
                  name="outlet_email"
                  className={styles.numberInput}
                  value={outletDetailsSetup?.outlet_email}
                  maxLength={MAX_CHARS.outlet_email}
                  onChange={(e) =>
                    setOutletDetailsSetup({
                      ...outletDetailsSetup,
                      outlet_email: e.target.value,
                    })
                  }
                />
              </label>
            </div>
          </div>

          <div className={styles.formGroup}>
            <h2>Address Related</h2>

            <div className={styles.row}>
              <label className={styles.selectLabel}>
                Address
                <input
                  type="text"
                  name="outlet_typed_address"
                  className={styles.numberInput}
                  value={outletDetailsSetup?.outlet_address?.outlet_typed_address}
                  maxLength={MAX_CHARS.outlet_address}
                  onChange={(e) =>
                    setOutletDetailsSetup({
                      ...outletDetailsSetup,
                      outlet_address: {
                        ...outletDetailsSetup.outlet_address,
                        outlet_typed_address: e.target.value,
                      },
                    })
                  }
                />
              </label>
              <label className={styles.selectLabel}>
                Town
                <input
                  type="text"
                  name="outlet_town"
                  className={styles.numberInput}
                  value={outletDetailsSetup?.outlet_address?.outlet_town}
                  maxLength={MAX_CHARS.outlet_town}
                  onChange={(e) =>
                    setOutletDetailsSetup({
                      ...outletDetailsSetup,
                      outlet_address: {
                        ...outletDetailsSetup?.outlet_address,
                        outlet_town: e.target.value,
                      },
                    })
                  }
                />
              </label>
              <label className={styles.selectLabel}>
                District
                <input
                  type="text"
                  name="outlet_district"
                  className={styles.numberInput}
                  value={outletDetailsSetup?.outlet_address?.outlet_district}
                  maxLength={MAX_CHARS.outlet_district}
                  onChange={(e) =>
                    setOutletDetailsSetup({
                      ...outletDetailsSetup,
                      outlet_address: {
                        ...outletDetailsSetup?.outlet_address,
                        outlet_district: e.target.value,
                      },
                    })
                  }
                />
              </label>
            </div>
            <div className={styles.row}>
              <label className={styles.selectLabel}>
                State
                <input
                  type="text"
                  name="outlet_state"
                  className={styles.numberInput}
                  value={outletDetailsSetup?.outlet_address?.outlet_state}
                  maxLength={MAX_CHARS.outlet_state}
                  onChange={(e) =>
                    setOutletDetailsSetup({
                      ...outletDetailsSetup,
                      outlet_address: {
                        ...outletDetailsSetup?.outlet_address,
                        outlet_state: e.target.value,
                      },
                    })
                  }
                />
              </label>
              <label className={styles.selectLabel}>
                Country
                <input
                  type="text"
                  name="outlet_country"
                  className={styles.numberInput}
                  value={outletDetailsSetup?.outlet_address?.outlet_country}
                  maxLength={MAX_CHARS.outlet_country}
                  onChange={(e) =>
                    setOutletDetailsSetup({
                      ...outletDetailsSetup,
                      outlet_address: {
                        ...outletDetailsSetup?.outlet_address,
                        outlet_country: e.target.value,
                      },
                    })
                  }
                />
              </label>
              <label className={styles.selectLabel}>
                Area Pin
                <input
                  type="text"
                  name="outlet_area_pin"
                  className={styles.numberInput}
                  value={outletDetailsSetup?.outlet_address?.outlet_area_pin}
                  maxLength={MAX_CHARS.outlet_area_pin}
                  onChange={(e) =>
                    setOutletDetailsSetup({
                      ...outletDetailsSetup,
                      outlet_address: {
                        ...outletDetailsSetup?.outlet_address,
                        outlet_area_pin: e.target.value,
                      },
                    })
                  }
                />
              </label>
            </div>
          </div>

          <button type="submit" className={styles.submit}>
            Save changes
          </button>

        </div>
      </form>
      {customizationModalOpen && (
        <SetupModal onClose={() => setCustomizationModalOpen(false)}>
        </SetupModal>
      )}
    </>
  );
}

export default OutletDetailsSetupForm;
